import React, { FC, memo, PropsWithChildren } from 'react';
import { Container } from '~/templates/blocks/components/container/container.component';
import { ClubOverlays } from '~/features/club';
import styles from './header-wrapper.module.css';
import clsx from 'clsx';

type Props = PropsWithChildren & {
    className?: string;
};

const HeaderWrapper: FC<Props> = memo(({ className, children }) => (
    <>
        <header className={styles.root}>
            <Container
                spacingTop="none"
                spacingBottom="none"
                className={clsx(styles.container, className)}
            >
                {children}
            </Container>
        </header>
        <ClubOverlays />
    </>
));

HeaderWrapper.displayName = 'HeaderWrapper';
export default HeaderWrapper;
